
export class document {
    id:number;
    documentName :string;
    
    universityId :number=1;
    }